import { OfferSettingsProduct, OfferSettingsStatus } from '../domain/ListingsProducts';
import { OfferSettingsProductsDTO, OfferSettingsSaveDTO } from '../dtos/ListingsProductsDTO';

export const mapOfferSettingsListResponse = (dto: OfferSettingsProductsDTO): OfferSettingsProduct[] => {
  return dto.data;
};

export const mapOfferSettingsSaveResponse = (dto: OfferSettingsSaveDTO): OfferSettingsStatus => {
  return {
    status: dto.data.status,
    productsAllowed: dto.data.productsAllowed,
    productsDisallowed: dto.data.productsDisallowed,
  };
};
